import React from 'react';
import capitalize from 'lodash/capitalize';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { appendHoneyGuide } from '../../lib/utils';

class DocumentTitle extends React.Component {
  render() {
    return null;
  }

  componentDidUpdate() {
    const { location, appState } = this.props;
    const { pathname } = location;

    const currentScreen = this.getCurrentScreen(pathname);
    const screenTitle = this.getScreenTitle(currentScreen, appState);

    this.setScreenTitle(screenTitle);
  }

  componentDidMount() {
    const {
      location: { pathname = '' },
      appState,
    } = this.props;
    const currentScreen = this.getCurrentScreen(pathname);
    const screenTitle = this.getScreenTitle(currentScreen, appState, pathname);

    this.setScreenTitle(screenTitle);
  }

  setScreenTitle(screenTitle) {
    if (screenTitle) document.title = screenTitle;
  }

  getCurrentScreen(pathname) {
    pathname = pathname.toLowerCase();

    if (pathname.includes('.profile')) return 'profile';
    if (pathname.includes('/payment-success')) return 'payment-success';
    if (pathname.includes('/onboarding-form')) return 'onboarding-form';

    if (pathname.includes('/treks')) {
      if (pathname.match(/(day-[0-9]{1,2})$/)) return 'trek-day';
      if (pathname.includes('-region')) return 'trek';
      if (pathname.includes('/review-lodges')) return 'lodges-review';

      return 'trek listing';
    }

    if (pathname.includes('-region')) return 'place';

    if (pathname.includes('/places')) return 'place listing';

    if (pathname.includes('-lodge')) return 'lodge';

    if (pathname.includes('explore')) return 'explore';

    if (pathname.includes('/flights')) {
      if (pathname.includes('/passenger-details')) return 'passenger-details';

      if (pathname.includes('/details-review')) return 'details-review';

      if (pathname.includes('/booking-success')) return 'booking-success';

      return 'flights';
    }

    if (pathname.includes('/policies')) {
      if (pathname.includes('/terms-services')) return 'terms-services';

      if (pathname.includes('/privacy')) return 'privacy';

      if (pathname.includes('/copyright')) return 'copyright';

      if (pathname.includes('/payment')) return 'policies-payment';

      if (pathname.includes('/cancellation-refund')) return 'cancellation-refund';

      if (pathname.includes('/cookies')) return 'cookies';
    }

    if (pathname.includes('/signup')) {
      if (pathname.includes('/activation-failed')) return 'signup-activation-failed';
      if (pathname.includes('/pending-verification')) return 'signup-pending-verification';
      if (pathname.includes('/activate')) return 'signup-activate';
    }

    if (pathname.includes('/partners')) {
      return pathname.split('/')[2];
    }

    if (pathname.includes('/')) return 'landing';

    const isThePageStatic = pathname.split('/').length === 2;
    if (isThePageStatic) return 'staticPage';

    return '';
  }

  titleCameFromServer = () => {};

  getScreenTitle = (screen, state) => {
    const hg = 'HoneyGuide';

    switch (screen) {
      case 'landing':
      case 'trek':
      case 'trek-day':
      case 'trek listing':
      case 'place listing':
      case 'place':
      case 'lodge':
      case 'explore':
      case 'staticPage':
      case 'profile':
      case 'flights':
      case 'lodge-owners':
      case 'guides':
      case 'travel-agents':
      case 'non-residential-nepali':
      case 'bloggers':
      case 'press-center':
      case 'destination-promotion-organization':
      case 'bed-and-breakfasts':
        return;

      case 'payment-success':
        return appendHoneyGuide('Payment Success');

      case 'terms-services':
        return appendHoneyGuide('Terms Of Services');

      case 'privacy':
        return appendHoneyGuide('Privacy Policy');

      case 'copyright':
        return appendHoneyGuide('Copyright Policy');

      case 'cancellation-refund':
        return appendHoneyGuide('Cancellation and Refund Policy');

      case 'policies-payment':
        return appendHoneyGuide('Payment and Payout Policy');

      case 'cookies':
        return appendHoneyGuide('Cookie Policy');

      case 'lodge-payment':
        return appendHoneyGuide('Lodge Payment');

      case 'passenger-details':
        return appendHoneyGuide('Flights Passenger Details');

      case 'details-review':
        return appendHoneyGuide('Flights Details Review');

      case 'booking-success':
        return appendHoneyGuide('Flights Booking Success');

      case 'signup-activation-failed':
        return appendHoneyGuide('Account Activation Failed');

      case 'signup-pending-verification':
        return appendHoneyGuide('Pending Verification');

      case 'signup-activate':
        return appendHoneyGuide('Activate Account');

      case 'onboarding-form':
        return appendHoneyGuide('Onboarding Form');

      default:
        return hg;
    }
  };

  getTitleForStaticPage = () =>
    this.props.location.pathname
      .split('/')[1]
      .replace(/-/g, ' ')
      .split(' ')
      .map(str => capitalize(str))
      .join(' ');
}

const mapStateToProps = state => ({ appState: state });

export default withRouter(connect(mapStateToProps)(DocumentTitle));



// WEBPACK FOOTER //
// ./src/components/DocumentTitle/DocumentTitle.jsx